// extracted by mini-css-extract-plugin
export var textInput = "_kk-0";